import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useUrl } from '.'
import { Apis } from '../appSettings/AppSettings'

const QUERY_KEY = 'dummyPersons'

export const useGetDummyPersons = () => {
  const url = useUrl(Apis.person)

  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => apiClient.get<PersonAdditionalData[]>(`${url}/GetDummyPersons`).then(res => res.data),
  })
}

export const useCreateDummyPerson = () => {
  const url = useUrl(Apis.person)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (dto: PersonAdditionalData) => apiClient.post<PersonAdditionalData>(`${url}/CreateDummyPerson`, dto).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    },
  })
}

export const useUpdateDummyPerson = () => {
  const url = useUrl(Apis.person)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (dto: PersonAdditionalData) => apiClient.put<PersonAdditionalData>(`${url}/UpdateDummyPerson`, dto).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    },
  })
}

export const useDeleteDummyPerson = () => {
  const url = useUrl(Apis.person)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => apiClient.delete(`${url}/DeleteDummyPerson`, { params: { id } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    },
  })
}
